import { render, staticRenderFns } from "./OffersGrid.vue?vue&type=template&id=2b8397bf"
import script from "./OffersGrid.vue?vue&type=script&lang=js"
export * from "./OffersGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports